import { DataSourceSpecInfoBase } from "abweb/dto/generated/ds/DataSourceSpecInfoBase";
export class DataSourceSpecInfo extends DataSourceSpecInfoBase {
  constructor() {
    super();
  }
}
//# sourceMappingURL=DataSourceSpecInfo.js.map
